import {Component , Inject , OnInit , ViewEncapsulation} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import {FormControl , FormGroup , Validators} from '@angular/forms';
import {DomSanitizer} from "@angular/platform-browser";
import {OrganizationsService} from "../../../../../core/services/organizations.service";
import {FrontUserService} from "../../../../../core/services/frontUsers.service";
import {EventTypeService} from "../../../../../core/services/eventType.service";
import {ToastrService } from "ngx-toastr";
import moment from 'moment';

@Component({
    selector: 'event-dialog',
    templateUrl: './setting-form.component.html',
    styleUrls: ['./setting-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class EventDialogComponent implements OnInit {
  events = [];
  targetGroups = [];
  eventType = [];
  all = false;
  msg;
  eventTypes;
  users;
  constructor (private organizationService: OrganizationsService ,
               public dialog: MatDialog ,
               public toastr: ToastrService  ,
               private eventService: EventTypeService ,
               private userService: FrontUserService ,
               public dialogRef: MatDialogRef<EventDialogComponent> ,
               @Inject(MAT_DIALOG_DATA) private data: any , private satinaizer: DomSanitizer) {
    this.organizationService.getOldEvent(data.oldID, data.id).subscribe((res: any) => {
      this.msg = res.msg;
      if (res && res.msg === 'done') {
        this.events = res[ 'events' ];
      }
    });
    this.eventService.getEventTypeDropDown().subscribe((res: any) => {
      this.eventTypes = res;
    });
    this.userService.getTargetGroup().subscribe((res: any) => {
      this.targetGroups = res.targetGroups;
    });
    this.organizationService.getUserByOrganization(data.id).subscribe((res: any) => {
      this.users = res;
    });
  }

  ngOnInit () {

  }

  openTgDialog (item , index) {
    const dialogRef = this.dialog.open(EventDialog , {
      width: '70vw' ,
      data: {
        item: item ,
        eventTypes: this.eventTypes,
        targetGroups: this.targetGroups,
        users: this.users
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        item.credits = result.credits;
        item.dateVisibleFrom = result.dateVisibleFrom;
        item.dates = result.dates;
        item.description = result.description;
        item.internalDescription = result.internalDescription;
        item.endOfReservation = result.endOfReservation;
        item.eventTypeId = result.eventTypeId;
        item.gender = result.gender;
        item.maxParticipans = result.maxParticipans;
        item.minParticipans = result.minParticipans;
        item.targetGroup = result.targetGroup
        item.tg = result.tg;
        item.user = result.user;
        item.userId = result.userId;
        item.title = result.title;
        item.type = result.type;
        item.reservationPossible = result.reservationPossible;
      }
    });
  }


  selectAll () {
    console.log(this.all);
    for (let i = 0; i < this.events.length; i++) {
      this.events[ i ].selected = this.all;
    }
  }

  checkAll () {
    let count = 0;
    for (let i = 0; i < this.events.length; i++) {
      if (this.events[ i ].selected) {
        count++;
      }
    }
    if (this.events.length === count) {
      this.all = true;
    } else {
      this.all = false;
    }
  }

  saveEvent () {
    for (let i = 0; i < this.events.length; i++) {
      if (this.events[i].selected) {
        this.events[ i ].oldEventId = this.events[ i ].id;
        this.events[ i ].targetGroup =  this.events[ i ].targetGroup.toString();
        this.events[ i ].dates =  this.events[ i ].dates ? moment(this.events[ i ].dates).format('DD.MM.YYYY') : '';
        this.events[ i ].dateVisibleFrom = this.events[ i ].dateVisibleFrom ? moment(this.events[ i ].dateVisibleFrom).format('DD.MM.YYYY') : '';
        this.events[ i ].endOfReservation = this.events[ i ].endOfReservation ? moment(this.events[ i ].endOfReservation).format('DD.MM.YYYY') : '';
        this.organizationService.importEvent(this.events[ i ]).subscribe((res: any) => {
          if (res) {
            this.toastr.success('Event ' + res.title + ' added' , 'Success!' );
          }
        });
      }
    }
     this.dialogRef.close();
  }


}

@Component({
    selector: 'event-example-dialog',
    templateUrl: 'event-dialog.html',
    styles: [`.width-50 {
    width: 50%;
    padding: 10px;
  }

  .width-100 {
    width: 100%;
    padding: 10px;
  }

  .width-75 {
    width: 75%;
    padding: 10px;
  }

  .width-33 {
    width: 33%;
    padding: 10px;
  }

  .width-25 {
    width: 25%;
    padding: 10px;
  }`],
    standalone: false
})
export class EventDialog {
  public form: FormGroup = new FormGroup({
    title: new FormControl('' , Validators.required) ,
    description: new FormControl('' , Validators.required) ,
    internalDescription: new FormControl('') ,
    eventTypeId: new FormControl('' , Validators.required) ,
    credits: new FormControl('') ,
    userId: new FormControl('') ,
    maxParticipants: new FormControl('') ,
    minParticipants: new FormControl('') ,
    gender: new FormControl('') ,
    targetGroup: new FormControl('') ,
    dates: new FormControl('') ,
    dateVisibleFrom: new FormControl('') ,
    endOfReservation: new FormControl(''),
    reservationPossible: new FormControl(false)
  });
  type;
  public formErrors: any = {
    title: {} ,
    description: {} ,
    eventTypeId: {}
  };

  constructor (public dialogRef: MatDialogRef<EventDialog> ,
               @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
    if (data.item.tg.length) {
      data.item.targetGroup = [];
      for (let i = 0; i < data.item.tg.length; i++) {
        data.item.targetGroup.push(data.item.tg[i].id);
      }
    }
    this.form.patchValue(data.item);
    this.type = data.item.type;
  }

  onNoClick (type): void {
    if (type === 'close') {
      this.dialogRef.close();
    }

    if (type === 'change') {
      let data = this.form.getRawValue();
      data.type = this.type;
      data.user = this.data.users.find(o => o.id === data.userId);
      if (data.targetGroup.length) {
        data.tg = [];
        for (let i = 0; i < data.targetGroup.length; i++) {
          data.tg.push(this.data.targetGroups.find(o => o.id === data.targetGroup[i]));
        }
      }
      this.dialogRef.close(data);
    }
  }
  get f () {
    return this.form.controls;
  }
  changeEventLevel(event) {
    console.log(event.value);
    this.type = this.data.eventTypes.find(o => o.id === event.value);
  }
}

